import { Map as ImmutableMap } from 'immutable';
import { FetchHubContactActionTypes } from '../actions/HubContactActions';
import { handleActions } from 'flux-actions';
const initialState = ImmutableMap({
  isHubContact: false
});
export default handleActions({
  [FetchHubContactActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('isHubContact', action.payload.data.hubContact);
  }
}, initialState);